import React from 'react';

import { useIntl } from 'react-intl-next';

import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const initialsAvatarColor = token('color.background.neutral');
const personAvatarColor = token('color.icon');
const textColor = token('color.text');

const defaultAvatarCSS = xcss({
	padding: 'space.025',
	alignItems: 'center',
	display: 'flex',
});

const initialsAvatarCSS = xcss({
	alignItems: 'center',
	display: 'flex',
});

function getInitials(name: string): string {
	const names = name.split(' ');
	const lastName = names.length > 1 ? names[names.length - 1] : '';
	const firstInitial = names[0][0].toUpperCase();
	const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
	return firstInitial + lastInitial;
}

interface AvatarProps {
	name?: string;
}

export const Avatar = ({ name }: AvatarProps) => {
	// fg('use_initials_avatar_icon_3pmessages') => false
	const useInitialsAvatar = false && name;
	const { formatMessage } = useIntl();

	return (
		<>
			{useInitialsAvatar ? (
				<Box testId="3p-message-avatar" xcss={initialsAvatarCSS}>
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						aria-label={formatMessage(messages.initialsAvatarLabel)}
					>
						<circle cx="10" cy="10" r="10" fill={initialsAvatarColor} />
						<text
							x="50%"
							y="55%"
							fontFamily="SF Pro Text, sans-serif"
							dominantBaseline="middle"
							textAnchor="middle"
							fontSize="11"
							fontWeight="400"
							fill={textColor}
						>
							{getInitials(name)}
						</text>
					</svg>
				</Box>
			) : (
				<Box xcss={defaultAvatarCSS} testId="3p-message-avatar">
					<PersonAvatarIcon
						label={formatMessage(messages.personAvatarLabel)}
						color={personAvatarColor}
					/>
				</Box>
			)}
		</>
	);
};
